import styled from "styled-components";

export default styled.p`
    display: block;
    word-break: break-all;
    white-space: nowrap;
    padding: 0;
    margin: 2px 0;
    min-height: 1em;
    height: 1em;
    line-height: 1em;
  
    & *::selection {
        color: #1a140d;
        background: #ffcf09;
    }
`